<template>
  <div class="blog-wrapper">
    <skeleton-blog v-if="firstLoad"></skeleton-blog>
    <div v-else-if="Object.keys(firstItem).length !== 0">
      <transition name="slide-fade" appear>
        <featured-blog :item="firstItem"></featured-blog>
      </transition>

      <div class="card-list mx-0 lg:-mx-5">
        <transition-group name="list" appear tag="div" class="flex flex-wrap">
          <card-blog
            v-for="item in itemsToIterate"
            :item="item"
            :key="item.id"
            class="w-full py-4 px-0 lg:w-1/3 lg:p-5"
          >
          </card-blog>
        </transition-group>
      </div>
    </div>
    <div v-else class="text-center">
      <h3>We can't show our posts!</h3>
    </div>

    <v-snackbar
      v-model="snackbar"
      :color="snackbarType"
      content-class="text-center"
    >
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import FeaturedBlog from "./FeaturedBlog";
import CardBlog from "./CardBlog";
import SkeletonBlog from "./SkeletonBlog";

export default {
  components: {
    FeaturedBlog,
    CardBlog,
    SkeletonBlog,
  },
  data: () => {
    return {
      items: [],
      firstItem: {},
      locale: window.appLocale,
      page: 1,
      last_page: 1,
      pageSize: 4,
      firstLoad: true,
      fetching: false,
      snackbar: false,
      snackbarType: "",
      snackbarText: "",
    };
  },
  computed: {
    itemsToIterate() {
      return window.innerWidth >= 1024
        ? this.items
        : [this.firstItem, ...this.items];
    },
  },
  methods: {
    async getInitialData() {
      [this.firstItem, ...this.items] = await this.getPosts();
      this.firstLoad = false;
    },
    async getPosts() {
      try {
        this.fetching = true;
        const { data: response } = await axios.get("/api/posts", {
          params: {
            page: this.page++,
            per_page: this.pageSize,
            locale: window.appLocale,
          },
        });
        this.last_page = response.meta.last_page;

        this.fetching = false;

        if (response.data?.length == 0) throw "Error, no posts found!";

        return response.data;
      } catch (error) {
        this.showSnackBar("error", error);
        this.firstLoad = false;
      }
    },
    getNextData() {
      window.onscroll = async () => {
        const pointToMakeCall = document.documentElement.offsetHeight - 1110;
        const currentPointview = Math.round(
          document.documentElement.scrollTop + window.innerHeight
        );

        const pointReached =
          (currentPointview > pointToMakeCall - 300 &&
            currentPointview < pointToMakeCall + 300) ||
              current >= document.body.offsetHeight;

        if (pointReached && !this.fetching && this.page <= this.last_page) {
          const items = await this.getPosts();
          this.items = [...this.items, ...items];
        }
      };
    },
    showSnackBar(type, text) {
      this.snackbarType = type;
      this.snackbarText = text;
      this.snackbar = true;
    },
  },
  beforeMount() {
    this.getInitialData();
  },
  created() {
    this.getNextData();
  },
};
</script>
